import { Paper, CircularProgress } from "@mui/material";
import DatePicker from "react-datepicker";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PermPhoneMsgOutlinedIcon from "@mui/icons-material/PermPhoneMsgOutlined";
import { toast } from "react-toastify";
import SequentialCountdownTimer from "../sequentialCountDownTimer/SequentialCountDownTimer";
import IncreamentalTimer from "../increamentalTimer/IncreamentalTimer";
import CaseStageUpdationAndDocInfo from "../editCases/CaseStageUpdationAndDocInfo";
import CaseRecordings from "../caseRecordings/CaseRecordings";
import RefreshIcon from "../../../assets/caseMappingIcon.svg";
import UploadIcon from "../../../assets/uploadIcon.svg";
import TooltipIcon from "../../../assets/tooltipTriangle.svg";
import EditIcon from "../../../assets/editIcon.svg";
import DeleteIcon from "../../../assets/deleteIcon.svg";
import MappedDocInfo from "../editCases/MappedDocInfo";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { useDispatch } from "react-redux";
import { fetchUserAssignedCases } from "../../../redux/caseDetailsSlice";
import { ReportServices } from "../../../services/ReportServices";
import { RpaServices } from "../../../services/RpaServices";
import { HospitalServices } from "../../../services/HospitalServices";
import { CaseServices } from "../../../services/CaseServices";
import ReprocessButton from "./ReprocessButton";
import MoveOutOfAiAnalysisButton from "./MoveOutOfAiAnalysisButton";
import CountdownTimer from "../../../utils/countDownTimer";
import InitiateCountdownTimer from "../../../utils/InitiateCountDownTimer";
export default function CaseTable({
  cases,
  isLoading,
  users,
  stageTimeColor,
  setAssignUser,
  user,
  setConfirmationPopup,
  setUpdateStageMethodName,
  setSelectedCase,
  setPreinitiateOpen,
  setCurrentCommandCenterStage,
  showRecordings,
  setShowRecordings,
  outsideUser,
  navigate,
  assignedFilter,
  filteredUnassignedCases,
  totalFilteredCases,
  caseAssignMessage,
  getStageCaseReport,
  setShowDeactvateModal,
  selectedStage, // if needed
  AllCases,
}) {
  const dispatch = useDispatch();
  const handleAssignClick = async (cas) => {
    try {
      const commandCenterStage =
        cas?.submasterstagestatuses?.[0]?.commandCenterStage;

      await ReportServices.assignCaseStage(
        cas.submasterstagestatuses[0]?.id,
        user?.user?.id,
        false,
      );

      if (commandCenterStage?.toLowerCase()?.includes("in rpa queue")) {
        const data = { caseIds: [cas.id] };
        await RpaServices.moveOutOfRpaQueue(data);
      }

      await AllCases();
      dispatch(fetchUserAssignedCases());
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleReprocessAiCase = async (cas) => {
    const data = {
      caseIds: [cas.id],
    };
    try {
      const res = await CaseServices?.reProcessAiAnalysisCases(data);
      await AllCases();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleMoveAiCaseToReverify = async (cas) => {
    const data = {
      caseIds: [cas.id],
    };
    try {
      const res = await CaseServices?.moveAIcaseToReverify(data);
      await AllCases();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const STAGE_TAB_MAPPING = {
    "request admission initiated": "CASE DETAILS",

    "admission documents uploaded": "UPDATE DOCUMENTS",
    "admission documents approved by team b": "UPDATE DOCUMENTS",
    "admission documents re-uploaded": "UPDATE DOCUMENTS",
    "admission query on tms": "UPDATE DOCUMENTS",
    "admission query documents uploaded": "UPDATE DOCUMENTS",
    "admission query documents approved by doctor": "UPDATE DOCUMENTS",
    "admission query documents re-uploaded": "UPDATE DOCUMENTS",
    "ai rejected admission documents re-verify": "UPDATE DOCUMENTS",
    "ai rejected enhancement documents re-verify": "UPDATE DOCUMENTS",
    "ai rejected claim documents re-verify": "UPDATE DOCUMENTS",

    "admission documents approved by team c": "DOWNLOAD DOCUMENTS",
    "admission query documents approved by sr doctor": "DOWNLOAD DOCUMENTS",

    "request enhancement initiated": "MAP DOCUMENTS",

    "enhancement documents uploaded.": "UPDATE DOCUMENTS",
    "enhancement documents re-uploaded": "UPDATE DOCUMENTS",
    "enhancement query on tms": "UPDATE DOCUMENTS",
    "enhancement query documents uploaded": "UPDATE DOCUMENTS",
    "enhancement  query documents uploaded": "UPDATE DOCUMENTS",
    "enhancement query documents re-uploaded": "UPDATE DOCUMENTS",
    "enhancement documents approved by team d": "UPDATE DOCUMENTS",
    "enhancement query documents approved by doctor": "UPDATE DOCUMENTS",

    "enhancement  documents  approved by team e": "DOWNLOAD DOCUMENTS",
    "enhancement query documents approved by sr doctor": "DOWNLOAD DOCUMENTS",
    "request to add new enhancement procedure": "CASE DETAILS",

    "request discharge initiated": "MAP DOCUMENTS",

    "claim documents uploaded": "UPDATE DOCUMENTS",
    "claim documents re- uploaded": "UPDATE DOCUMENTS",
    "claim documents approved by team d": "UPDATE DOCUMENTS",

    "claim documents  approved by team e": "DOWNLOAD DOCUMENTS",

    "claim query on tms": "UPDATE DOCUMENTS",
    "claim query documents uploaded": "UPDATE DOCUMENTS",
    "claim query documents re-uploaded": "UPDATE DOCUMENTS",
    "claim query documents approved by doctor": "UPDATE DOCUMENTS",

    "claim query documents approved by sr doctor": "DOWNLOAD DOCUMENTS",
  };
  const DUT_STAGES = [
    "AI Rejected Admission Documents Re-Verify",
    "AI Rejected Enhancement Documents Re-Verify",
    "AI Rejected Claim Documents Re-Verify",
  ];
  const getFormattedAge = (birthDate) => {
    if (!birthDate) return "";
    const today = new Date();
    const birthDateObj = new Date(birthDate);

    let years = today.getFullYear() - birthDateObj.getFullYear();
    let months = today.getMonth() - birthDateObj.getMonth();
    let days = today.getDate() - birthDateObj.getDate();

    if (days < 0) {
      months -= 1;
      // Get the number of days in the previous month
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }

    let ageStr = "";
    if (years > 0) ageStr += `${years}yr`;
    if (months > 0) ageStr += `${months}m`;
    if (days > 0) ageStr += `${days}d`;
    if (!ageStr) ageStr = "0d";
    return ageStr;
  };

  function getRedirectTab(stage) {
    if (!stage) return "HOSPITAL DETAILS";

    const normalizedStage = stage.toLowerCase().trim();

    return STAGE_TAB_MAPPING[normalizedStage] || "HOSPITAL DETAILS";
  }
  return (
    <Paper style={{ backgroundColor: "#f5f5f5" }} className="list-paper">
      {/* Table header */}
      <div className="grid grid-cols-9 text-[#191919] font-semibold px-[14px] py-4">
        <div>Beneficiary No.</div>
        <div>Patient Name</div>
        <div>Case ID/Reg Id</div>
        {/* <div>HUID</div> */}
        <div>Hospital Name</div>
        <div>City</div>
        <div>State</div>
        <div>Gender/Age</div>
        <div>Case Type</div>
        <div>Registered Date</div>
      </div>

      {isLoading ? (
        <div className="flex items-center justify-center p-20">
          <CircularProgress />
        </div>
      ) : (
        <div className="h-screen overflow-y-scroll">
          {cases && cases.length > 0 ? (
            cases.map((cas, idx) => (
              <div
                key={cas.id || idx}
                style={{
                  border: "1px solid #E5E5E5",
                  marginTop: idx === 0 ? "4px" : "24px",
                }}
                className="relative bg-white px-[14px] py-4 rounded-[8px] mb-3 hovernow"
              >
                {cas?.caseSubType === "DIALYSIS" &&
                  !cas.submasterstagestatuses[0]?.assignedTo &&
                  cas?.submasterstagestatuses?.[0]?.commandCenterStage
                    ?.toLowerCase()
                    ?.includes("ai analysis") && (
                    <div className="absolute inset-0 z-30 rounded-[8px] backdrop-blur-sm bg-white/40 flex items-center justify-center gap-4">
                      {/* {?<CircularProgress/> : <div
                        className="absolute top-3 right-3 z-40"
                        onClick={() => handleReprocessAiCase(cas)}
                      >
                        <img src={RefreshIcon} alt="refresh-icon" />{" "}
                      </div>} */}
                      <MoveOutOfAiAnalysisButton
                        createdAt={cas?.submasterstagestatuses?.[0]?.createdAt}
                        onMoveToReverify={() => handleMoveAiCaseToReverify(cas)}
                      />
                      {/* <div
                        className="absolute top-1 right-10 text-xs font-medium border border-solid border-[#017C57] px-4 py-2 rounded-full cursor-pointer"
                        onClick={() => handleMoveAiCaseToReverify(cas)}
                      >
                        Move Out Of AI Analysis
                      </div> */}
                      <ReprocessButton
                        createdAt={cas?.submasterstagestatuses?.[0].createdAt}
                        onRefresh={() => handleReprocessAiCase(cas)}
                      />

                      <div className="font-semibold">
                        AI is reviewing the documents
                      </div>
                      <div
                        className="text-[#797979] text-sm flex gap-1 items-center"
                        title="Current Stage Time"
                      >
                        <IncreamentalTimer
                          colorData={
                            stageTimeColor?.colorData[
                              stageTimeColor?.subMainStageIdPair[
                                cas.submasterstagestatuses[0]?.commandCenterStage.toLowerCase()
                              ]
                            ]
                          }
                          createdAt={cas.submasterstagestatuses[0]?.createdAt}
                          cases={cases}
                          index={idx}
                        />
                      </div>
                      <div
                        style={{ border: "1px solid #CF3636" }}
                        className="text-xs text-[#CF3636] font-semibold px-3 py-1 rounded-full cursor-pointer"
                        title="Assign Case Stage to User"
                        onClick={() => {
                          const createdAt =
                            cas.submasterstagestatuses[0]?.createdAt;
                          const isAssignable =
                            createdAt &&
                            Date.now() - new Date(createdAt).getTime() >=
                              10 * 60 * 1000;

                          const isAdmin = user?.roles?.some(
                            (role) => role.roleId === 7,
                          );

                          if (isAssignable || isAdmin) {
                            handleAssignClick(cas);
                          } else {
                            toast.info("Case is not assignable");
                          }
                        }}
                      >
                        Assign
                      </div>
                    </div>
                  )}

                <div className="grid grid-cols-9 text-sm 2xl:text-base text-[#191919] mb-5 ">
                  {/* Beneficiary No. with checkbox */}
                  <div className="flex gap-1 items-start">
                    <input type="checkbox" className="h-[16px] w-[16px]" />
                    <div
                      className="overflow-hidden whitespace-nowrap text-ellipsis"
                      title={cas?.patient?.beneficiaryNo}
                    >
                      {cas?.patient?.beneficiaryNo}
                    </div>
                  </div>

                  {/* Patient Name */}
                  <div
                    className="overflow-hidden whitespace-nowrap text-ellipsis"
                    title={cas?.patient?.patientName}
                  >
                    {cas?.patient?.patientName}
                  </div>

                  {/* Case ID / Reg Id with copy icon */}
                  {cas?.pmjayRegistrationId || cas?.pmjayId ? (
                    <div
                      className="overflow-hidden whitespace-nowrap text-ellipsis cursor-pointer"
                      title={cas?.pmjayId}
                      onClick={() =>
                        navigator.clipboard.writeText(
                          cas?.pmjayRegistrationId || cas?.pmjayId,
                        )
                      }
                    >
                      <ContentCopyIcon
                        className="cursor-pointer active:bg-slate-400 mr-1"
                        fontSize="12px"
                        onClick={(e) => {
                          e.stopPropagation(); // prevent double click bubbling
                          navigator.clipboard.writeText(
                            cas?.pmjayRegistrationId || cas?.pmjayId,
                          );
                          toast.success("Registration Id copied successfully");
                        }}
                      />
                      {cas?.pmjayRegistrationId || cas.pmjayId}
                    </div>
                  ) : (
                    <div className="flex gap-1 items-center justify-center">
                      --
                    </div>
                  )}

                  {/* HUID */}
                  {/* <div
                    className="overflow-hidden whitespace-nowrap text-ellipsis"
                    title={cas?.hospitalId}
                  >
                    {cas?.hospitalId}
                  </div> */}

                  {/* Hospital Name */}
                  <div
                    className="overflow-hidden whitespace-nowrap text-ellipsis pl-1"
                    title={cas?.hospital?.name}
                  >
                    {cas?.hospital?.name}
                  </div>

                  {/* City */}
                  <div
                    className="overflow-hidden whitespace-nowrap text-ellipsis"
                    title={cas?.hospital?.city}
                  >
                    {cas?.hospital?.city}
                  </div>

                  {/* State */}
                  <div
                    className="overflow-hidden whitespace-nowrap text-ellipsis"
                    title={cas?.hospital?.state}
                  >
                    {cas?.hospital?.state}
                  </div>

                  {/* Gender / Age with color highlight if age >= 60 */}
                  <div className="flex justify-center">
                    <div
                      className={`w-fit ${(() => {
                        const ageStr = getFormattedAge(cas?.patient?.birthDate);
                        const match = ageStr.match(/^(\d+)yr/);
                        const years = match ? parseInt(match[1], 10) : 0;
                        return years > 60
                          ? "text-white bg-[#FF8686] text-sm"
                          : "";
                      })()} p-1 rounded-[4px]`}
                    >
                      {cas?.patient?.gender?.slice(0, 1)}/
                      {cas?.patient?.birthDate
                        ? getFormattedAge(cas?.patient?.birthDate)
                        : cas?.patient?.age}
                    </div>
                  </div>

                  {/* Case Type */}
                  <div>
                    {cas?.caseType === "DAYCARE" &&
                    cas?.caseSubType?.toUpperCase() === "DIALYSIS"
                      ? `${cas.caseType} (${cas.caseSubType.charAt(0) + cas.caseSubType.slice(1).toLowerCase()})`
                      : cas?.caseType}
                  </div>

                  {/* Registered Date with DatePicker disabled */}
                  <div>
                    {cas?.patient?.registeredDate && (
                      <DatePicker
                        selected={new Date(cas?.patient?.registeredDate)}
                        className="text-[#191919] font-medium border-none bg-transparent"
                        timeInputLabel="Time:"
                        dateFormat="dd/MM/yyyy h:mm aa"
                        showTimeInput
                        disabled
                      />
                    )}
                  </div>
                </div>

                {/* <CaseStageUpdationAndDocInfo
                  cas={cas}
                  setConfirmationPopup={setConfirmationPopup}
                  setUpdateStageMethodName={setUpdateStageMethodName}
                  setSelectedCase={setSelectedCase}
                  setPreinitiateOpen={setPreinitiateOpen}
                /> */}

                {/* Below, complex UI, timers, assigned users, buttons, modals etc */}
                {cas?.submasterstagestatuses &&
                  cas.submasterstagestatuses.length > 0 && (
                    <div className="flex justify-between items-center">
                      <div className="flex gap-2 items-center">
                        <div
                          className="text-[10px] 2xl:text-xs font-semibold px-4 py-1 rounded-full"
                          style={
                            cas.status === "INACTIVE"
                              ? { backgroundColor: "#FFEAC6", color: "#9D6B2A" }
                              : { backgroundColor: "#CDFAF4", color: "#017C57" }
                          }
                        >
                          {cas.status}
                        </div>

                        <SequentialCountdownTimer
                          colorData={
                            stageTimeColor?.colorData?.[
                              stageTimeColor?.subMainStageIdPair?.[
                                cas.submasterstagestatuses.length > 0
                                  ? cas.submasterstagestatuses[0]?.commandCenterStage.toLowerCase()
                                  : ""
                              ]
                            ]
                          }
                          createdAt={
                            cas.submasterstagestatuses.length > 0
                              ? cas.submasterstagestatuses[0]?.createdAt
                              : null
                          }
                        />

                        <div
                          className={`${
                            cas.submasterstagestatuses[0]?.commandCenterStage
                              .toLowerCase()
                              .includes("pending")
                              ? "text-[#9D6B2A] bg-[#FFEAC6]"
                              : cas.submasterstagestatuses[0]?.commandCenterStage
                                    .toLowerCase()
                                    .includes("rejected")
                                ? "text-[#CF3636] bg-[#FFD6DB]"
                                : "text-[#017C51] bg-[#CDFAF4]"
                          }  text-[10px] 2xl:text-xs font-semibold uppercase rounded-full px-4 py-1`}
                        >
                          {cas.submasterstagestatuses[0]
                            ?.commandCenterStageText ||
                            cas.submasterstagestatuses[0]?.commandCenterStage}
                        </div>

                        <div className="text-[#797979] text-sm mx-2">
                          NSU:{" "}
                          <span className="text-xs 2xl:text-sm text-[#191919] font-semibold">
                            {cas.submasterstagestatuses[0]?.nextStepUser ||
                              "---"}
                          </span>
                        </div>

                        <div
                          className="text-[#797979] text-sm flex gap-1 items-center"
                          title="Current Stage Time"
                        >
                          <IncreamentalTimer
                            colorData={
                              stageTimeColor?.colorData[
                                stageTimeColor?.subMainStageIdPair[
                                  cas.submasterstagestatuses[0]?.commandCenterStage.toLowerCase()
                                ]
                              ]
                            }
                            createdAt={cas.submasterstagestatuses[0]?.createdAt}
                            cases={cases}
                            index={idx}
                          />
                        </div>

                        {((cas?.submasterstagestatuses?.[0]?.commandCenterStage
                          ?.toLowerCase()
                          ?.includes("admission") &&
                          !cas?.submasterstagestatuses?.[0]?.commandCenterStage
                            ?.toLowerCase()
                            ?.includes("query") &&
                          !cas?.submasterstagestatuses?.[0]?.commandCenterStage
                            ?.toLowerCase()
                            ?.includes("not initiated") &&
                          !cas?.submasterstagestatuses?.[0]?.commandCenterStage
                            ?.toLowerCase()
                            ?.includes("tms")) ||
                          (cas?.submasterstagestatuses?.[0]?.commandCenterStage
                            ?.toLowerCase()
                            ?.includes("claim") &&
                            cas?.summaryDetail?.tmsStageUpdateTime &&
                            !cas?.submasterstagestatuses?.[0]?.commandCenterStage
                              ?.toLowerCase()
                              ?.includes("query") &&
                            !cas?.submasterstagestatuses?.[0]?.commandCenterStage
                              ?.toLowerCase()
                              ?.includes("not initiated") &&
                            !cas?.submasterstagestatuses?.[0]?.commandCenterStage
                              ?.toLowerCase()
                              ?.includes("tms"))) && (
                          <>
                            <span className="text-sm text-[#797979]">
                              TAT :
                            </span>
                            {
                              <InitiateCountdownTimer
                                targetDate={
                                  cas?.submasterstagestatuses?.[0]?.commandCenterStage
                                    ?.toLowerCase()
                                    ?.includes("claim")
                                    ? new Date(
                                        new Date(
                                          cas?.summaryDetail
                                            ?.tmsStageUpdateTime,
                                        ).getTime() +
                                          168 * 60 * 60 * 1000,
                                      ).toISOString()
                                    : new Date(
                                        new Date(
                                          cas?.patient?.registeredDate,
                                        ).getTime() +
                                          48 * 60 * 60 * 1000,
                                      ).toISOString()
                                }
                              />
                            }
                          </>
                        )}
                      </div>

                      <div className="flex items-center gap-3">
                        <div>
                          {cas.submasterstagestatuses[0]?.assignedTo ? (
                            <div className="flex items-center gap-2">
                              {/* Assigned user name */}
                              <span className="text-[#191919] text-sm font-semibold">
                                {users &&
                                  users[
                                    cas.submasterstagestatuses[0].assignedTo
                                  ]}
                              </span>

                              {/* Reassign button: only if user has ALL permissions */}
                              {user?.user?.permissions === "ALL" && (
                                <button
                                  style={{
                                    border: "1px solid #017C57",
                                    background: "white",
                                    color: "#017C57",
                                    fontWeight: "bold",
                                    borderRadius: "999px",
                                    padding: "2px 12px",
                                    fontSize: "12px",
                                    marginLeft: "8px",
                                    cursor: "pointer",
                                  }}
                                  title="Reassign to another user"
                                  onClick={() =>
                                    setAssignUser({
                                      caseId: cas.id,
                                      commandCenterStage:
                                        cas.submasterstagestatuses[0]
                                          ?.commandCenterStage,
                                      commandCenterStageId:
                                        cas.submasterstagestatuses[0]?.id,
                                      reAssign: true,
                                    })
                                  }
                                >
                                  Reassign
                                </button>
                              )}
                            </div>
                          ) : (
                            // Unassigned case stage logic (show Assign as before)
                            <div
                              style={{ border: "1px solid #CF3636" }}
                              className="text-xs text-[#CF3636] font-semibold px-3 py-1 rounded-full cursor-pointer"
                              title="Assign Case Stage to User"
                              onClick={() => {
                                handleAssignClick(cas);
                              }}
                            >
                              Assign
                            </div>
                          )}
                        </div>

                        <MappedDocInfo cas={cas} />
                        {/* Example permission checks for buttons logic */}
                        {(user?.user?.id ===
                          cas.submasterstagestatuses[0]?.assignedTo ||
                          user?.user?.permissions === "ALL" ||
                          user?.user?.email === "staffb3teamb@outlook.com" ||
                          user?.user?.email ===
                            "drgajendrasingsettlemed@gmail.com") && (
                          <div className="flex gap-3 items-center">
                            {/* Upload icon with tooltip */}
                            <CaseStageUpdationAndDocInfo
                              cas={cas}
                              setConfirmationPopup={setConfirmationPopup}
                              setUpdateStageMethodName={
                                setUpdateStageMethodName
                              }
                              setSelectedCase={setSelectedCase}
                              setPreinitiateOpen={setPreinitiateOpen}
                              AllCases={AllCases}
                            />
                            {DUT_STAGES.includes(
                              cas?.submasterstagestatuses?.[0]
                                ?.commandCenterStage,
                            ) && (
                              <button
                                className="px-[16px] py-[8px] rounded-[24px] border border-[#017C57] text-[#017C57] bg-white text-[12px] font-[600]"
                                onClick={() =>
                                  navigate("/dashboard/dut-work-space", {
                                    state: {
                                      selectedCase: cas,
                                    },
                                  })
                                }
                              >
                                DOCUMENT REVERIFICATION
                              </button>
                            )}
                            <div
                              style={{ border: "1px solid #017C57" }}
                              className="group relative flex gap-2 px-2 py-2 rounded-full"
                            >
                              <div className="h-[14px] w-[14px] text-[10px] text-center text-[#FF1818] bg-[#FFC8C8] rounded-full">
                                {cas.referenceDocumentsRejected}
                              </div>
                              <div className="h-[14px] w-[14px] text-[10px] text-center text-[#017C57] bg-[#CDFAF4] rounded-full">
                                {cas.totalReferenceDocuments}
                              </div>
                              <img
                                src={UploadIcon}
                                alt="upload-icon"
                                className="w-[12px] cursor-pointer"
                                onClick={() => {
                                  const commandCenterStage =
                                    cas.submasterstagestatuses[0]
                                      ?.commandCenterStage;
                                  setPreinitiateOpen(true);
                                  setSelectedCase(cas);
                                  setCurrentCommandCenterStage(
                                    commandCenterStage,
                                  );
                                }}
                              />

                              <div className="w-[200%] hidden group-hover:block absolute text-xs top-[105%] -left-[50%] z-20">
                                <div className="w-full flex justify-center">
                                  <img src={TooltipIcon} alt="tooltip-icon" />
                                </div>
                                <div className="text-[12px] text-center text-white bg-[#017C57] py-2 px-1 rounded-[8px]">
                                  Reference Documents
                                </div>
                              </div>
                            </div>

                            {/* Phone icon and recordings */}
                            <div
                              className="cursor-pointer"
                              onClick={() => setShowRecordings(cas.id)}
                            >
                              <PermPhoneMsgOutlinedIcon
                                style={{ color: "#017C57" }}
                              />
                            </div>

                            {showRecordings === cas.id && (
                              <CaseRecordings
                                caseId={showRecordings}
                                isOpen={setShowRecordings}
                              />
                            )}

                            {/* Edit icon with tooltip */}
                            <div className="group relative">
                              <img
                                src={EditIcon}
                                alt="edit-icon"
                                className="cursor-pointer"
                                onClick={() => {
                                  const stage =
                                    cas?.submasterstagestatuses?.[0]
                                      ?.commandCenterStage;

                                  const tabToOpen = getRedirectTab(stage);

                                  outsideUser
                                    ? navigate("/Dashboard/EditCases/v2", {
                                        state: {
                                          selectedCase: cas,
                                          tab: tabToOpen,
                                        },
                                      })
                                    : cas?.submasterstagestatuses?.[0]?.commandCenterStage?.includes(
                                          "AI Analysis",
                                        )
                                      ? navigate("/dashboard/dut-work-space", {
                                          state: {
                                            selectedCase: cas,
                                          },
                                        })
                                      : navigate("/Dashboard/EditCases", {
                                          state: {
                                            selectedCase: cas,
                                            tab: tabToOpen,
                                          },
                                        });
                                }}
                              />
                              <div className="w-[300%] hidden group-hover:block absolute text-xs top-[100%] -left-[90%] z-20">
                                <div className="w-full flex justify-center">
                                  <img src={TooltipIcon} alt="tooltip-icon" />
                                </div>
                                <div className="text-[12px] text-center text-white bg-[#017C57] py-2 px-1 rounded-[8px]">
                                  Edit Case
                                </div>
                              </div>
                            </div>

                            {/* Delete icon shown for a specific user id */}
                            {user?.user?.id ===
                              "f72e5386-1bcd-4b81-91fc-412c68d0d9e2" && (
                              <div>
                                <img
                                  src={DeleteIcon}
                                  alt="delete-icon"
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setShowDeactvateModal(true);
                                    setSelectedCase(cas);
                                    getStageCaseReport();
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            ))
          ) : (
            <div className="text-xl text-center font-semibold mt-8">
              No Records Found
            </div>
          )}
        </div>
      )}
    </Paper>
  );
}
